import React from 'react';
import { Shield, Lock, Download, CreditCard } from 'lucide-react';
export const CHECKOUT_URL = 'https://pay.hotmart.com/V105318931X?checkoutMode=10';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: string;
  variant?: 'primary' | 'secondary';
  size?: 'lg' | 'xl';
  fullWidth?: boolean;
  scrollToOffer?: boolean;
}
export function Button({
  children,
  href,
  variant = 'primary',
  size = 'xl',
  fullWidth = true,
  scrollToOffer = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] text-center shadow-lg';
  const variants = {
    primary: 'bg-brand-green text-navy-900 hover:bg-[#2fb845] shadow-brand-green/25',
    secondary: 'bg-brand-red text-white hover:bg-red-600 shadow-brand-red/25'
  };
  const sizes = {
    lg: 'px-6 py-3 text-lg',
    xl: 'px-8 py-4 text-xl md:text-2xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (scrollToOffer) {
      e.preventDefault();
      document.getElementById('offer-section')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  if (href || scrollToOffer) {
    return <a href={scrollToOffer ? '#offer-section' : href || CHECKOUT_URL} className={classes} onClick={handleClick} data-id="element-175">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-176">
      {children}
    </button>;
}
export function TrustBadges() {
  return <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-xs md:text-sm text-gray-400 mt-4" data-id="element-177">
      <div className="flex items-center gap-1.5" data-id="element-178">
        <Lock className="w-4 h-4 text-brand-green" data-id="element-179" />
        <span data-id="element-180">Pago seguro</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-181">
        <Shield className="w-4 h-4 text-brand-green" data-id="element-182" />
        <span data-id="element-183">Garantía 45 días</span>
      </div>
      <div className="flex items-center gap-1.5" data-id="element-184">
        <Download className="w-4 h-4 text-brand-green" data-id="element-185" />
        <span data-id="element-186">Descarga inmediata</span>
      </div>
    </div>;
}
export function SectionBadge({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-navy-800 border border-navy-700 text-brand-green font-semibold text-sm mb-6 uppercase tracking-wider" data-id="element-187">
      {children}
    </div>;
}